import React, { useState, useEffect } from "react";
import { Flex, Box, Button, useToast, Spinner, Text } from "@chakra-ui/react";
import SearchableStoreSelect from "../../../Components/SearchableStoreSelect";
import { useNavigate } from "react-router-dom";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { PDFDownloadLink, PDFViewer } from "@react-pdf/renderer";
import { getFormatterDate } from "../../../helpers/date";
import { handleAuthError } from "../../../utils/auth";
import AlohaPDFComponent from "../Files/AlohaPDFComponent";
import { keyframes } from "@emotion/react";
import {
  processAlohaHeaderReading,
  processAlohaSalesData,
  proccessAlohaDiscount,
  processAlohaGrossBreakDown,
  processAlohaCashierBreakDown,
  processAlohaPaymentData,
  processAlohaNonSalesData,
  processAlohaNonSalesDataWithTenderDesc,
  processAlohaBillNOQTY,
  processAlohaNonSales,
} from "../../../helpers/eodReport";
import axios from "axios";

const dateCurr = new Date();
const blink = keyframes`
0% {opacity: 1;}
50% {opacity: 0;}
100% {opacity: 1;}
`;
const SalesSBC = ({ color }) => {
  const toast = useToast();
  const navigate = useNavigate();
  const [reqField, setReqField] = useState({
    date: new Date(),
    branch: "",
    locCode: "",
    storecode: "",
    costcenter: "",
  });
  const [stores, setStores] = useState([]);
  const [userAssignedStores, setUserAssignedStores] = useState([]);
  const [filteredStores, setFilteredStores] = useState([]);
  const role = localStorage.getItem("role");
  const [dataLoading, setDataLoading] = useState(false);
  const [data, setData] = useState();
  const handleDateChange = (date) => {
    setReqField((prev) => {
      return { ...prev, date: date };
    });
  };

  const handleBranchChange = (e) => {
    const storeList = role === "store" ? filteredStores : stores;
    const selectedStore = storeList.find(
      (store) => store.locCode === e.target.value,
    );
    if (selectedStore && selectedStore.StoreName) {
      setReqField((prev) => ({
        ...prev,
        branch: selectedStore.StoreName,
        locCode: selectedStore.locCode,
        storecode: selectedStore.storecode,
        costcenter: selectedStore.costcenter || selectedStore.storecode,
      }));
    }
  };
  const handleGenerateReport = async (date, branch) => {
    const newDate = getFormatterDate(date);
    const currDate = getFormatterDate(dateCurr);
    if (currDate < newDate) {
      toast({
        title: "Error",
        position: "top-right",
        description: "Date not Available.",
        status: "error",
        duration: 5000,
        isClosable: true,
      });
      return;
    }
    if (reqField.locCode === "") {
      toast({
        title: "Error",
        position: "top-right",
        description: "Please select a store.",
        status: "error",
        duration: 5000,
        isClosable: true,
      });
      return;
    }
    try {
      setDataLoading(true);
      // Helper function to check response type
      const isDataAvailable = (data) => Array.isArray(data) && data.length > 0;
      // Header
      const resHeader = await axios.get(
        `${process.env.REACT_APP_BACKEND_API_URL}/aloha/getHeaderReading.aspx?brand=SBC&qlik=${reqField.locCode}&datedfolder=${newDate.replace(/-/g, "")}`,
        { withCredentials: true },
      );
      if (!isDataAvailable(resHeader?.data))
        throw new Error("No header data found");
      const { totalGrossAmt, totalvat, openingData, closingData } =
        processAlohaHeaderReading(resHeader.data);
      // Sales Data
      const resSales = await axios.get(
        `${process.env.REACT_APP_BACKEND_API_URL}/aloha/getGrossSaleswithVat.aspx?brand=SBC&qlik=${reqField.locCode}&datedfolder=${newDate.replace(/-/g, "")}`,
        { withCredentials: true },
      );
      if (!isDataAvailable(resSales?.data))
        throw new Error("No sales data found");
      const { salesData } = processAlohaSalesData(resSales.data);
      // Discount Data
      const resDiscount = await axios.get(
        `${process.env.REACT_APP_BACKEND_API_URL}/aloha/getDiscount.aspx?brand=SBC&qlik=${reqField.locCode}&datedfolder=${newDate.replace(/-/g, "")}`,
        { withCredentials: true },
      );
      if (!isDataAvailable(resDiscount?.data))
        throw new Error("No discount data found");
      const { dataDiscount, dataDiscountVAT, dataDiscountVATE } =
        proccessAlohaDiscount(resDiscount.data);

      // Gross Breakdown
      const resGrossBreakDown = await axios.get(
        `${process.env.REACT_APP_BACKEND_API_URL}/aloha/getSaleswPerChannelithVat.aspx?brand=SBC&qlik=${reqField.locCode}&datedfolder=${newDate.replace(/-/g, "")}`,
        { withCredentials: true },
      );
      if (!isDataAvailable(resGrossBreakDown?.data))
        throw new Error("No Gross Breakdown data found.");
      const {
        dataGrossBreakDownReturned,
        totalGrossBreakDownVAT,
        totalGrossBreakDownVATE,
      } = processAlohaGrossBreakDown(resGrossBreakDown.data);

      // Payment Breakdown
      const resPaymentData = await axios.post(
        `${process.env.REACT_APP_BACKEND_API_URL}/aloha/getPaymentData.aspx?brand=SBC&qlik=${reqField.locCode}&datedfolder=${newDate.replace(/-/g, "")}`,
        null,
        { withCredentials: true },
      );
      if (!isDataAvailable(resPaymentData?.data))
        throw new Error("No payment breakdown data found.");
      const {
        totalPaymentCash,
        totalPaymentNonCash,
        paymentDataReturned,
        ChangeAmount,
        TenderAmount,
        VoidPaymentAmount,
        VoidPaymentCount,
        totalNonCashQty,
        NonSalesPaymentDataReturned,
        totalNonSalesCount,
      } = processAlohaPaymentData(resPaymentData.data);

      // Cashier Breakdown
      const resCashierBreakDown = await axios.post(
        `${process.env.REACT_APP_BACKEND_API_URL}/aloha/getCashAccountability.aspx?brand=SBC&qlik=${reqField.locCode}&datedfolder=${newDate.replace(/-/g, "")}`,
        null,
        { withCredentials: true },
      );
      if (!isDataAvailable(resCashierBreakDown?.data))
        throw new Error("No Cashier Breakdown data found.");
      const {
        cashierBreakDownReturned,
        totalCashierAmount,
        totalShortOver,
        shortOverDataReturned,
        totalShortOverNonCash,
        shortOverNonCashDataReturned,
        CMCash,
        CMFloat,
        CMOverShort,
        CMPickUp,
      } = processAlohaCashierBreakDown(resCashierBreakDown.data);

      // BillNoQTY
      const resBillQtyNo = await axios.post(
        `${process.env.REACT_APP_BACKEND_API_URL}/aloha/getBillNoAndQty.aspx?brand=SBC&qlik=${reqField.locCode}&datedfolder=${newDate.replace(/-/g, "")}`,
        null,
        { withCredentials: true },
      );
      if (!isDataAvailable(resBillQtyNo?.data))
        throw new Error("No BillNoQTY data found.");
      const { TCQty, OrderQty } = processAlohaBillNOQTY(resBillQtyNo.data);

      // Non Misc
      const resMisc = await axios.get(
        `${process.env.REACT_APP_BACKEND_API_URL}/aloha/getMisc.aspx?brand=SBC&qlik=${reqField.locCode}&datedfolder=${newDate.replace(/-/g, "")}`,
        { withCredentials: true },
      );
      if (!isDataAvailable(resMisc?.data))
        throw new Error("No Non Sales data found.");
      const { NonSalesDataReturned } = processAlohaNonSalesData(resMisc.data);

      // Non Cash with tenderDesk
      const resNonCashTenderDesk = await axios.get(
        `${process.env.REACT_APP_BACKEND_API_URL}/aloha/getNonCash.aspx?brand=SBC&qlik=${reqField.locCode}&datedfolder=${newDate.replace(/-/g, "")}`,
        { withCredentials: true },
      );
      if (!isDataAvailable(resNonCashTenderDesk?.data))
        throw new Error("No misc data found.");
      const { NonSalesWithTenderDesc, totalNonSales, totalNonSalesCounter } =
        processAlohaNonSalesDataWithTenderDesc(resNonCashTenderDesk.data);
      //Non Sales
      const resNonSales = await axios.get(
        `${process.env.REACT_APP_BACKEND_API_URL}/aloha/getNonsales.aspx?brand=SBC&qlik=${reqField.locCode}&datedfolder=${newDate.replace(/-/g, "")}`,
        { withCredentials: true },
      );
      if (!isDataAvailable(resNonSales?.data))
        throw new Error("No Non Cash with tenderDesk data found.");
      const { nonSalesData } = processAlohaNonSales(resNonSales.data);

      // Scrap Sales (Order Data)
      const resOrder = await axios.get(
        `${process.env.REACT_APP_BACKEND_API_URL}/aloha/getorder.aspx?brand=SBC&qlik=${reqField.locCode}&datedfolder=${newDate.replace(/-/g, "")}`,
        { withCredentials: true },
      );
      const orderData = isDataAvailable(resOrder?.data) ? resOrder.data : [];

      // Setting data after successful API responses
      setData({
        nonSalesData,
        currDate: currDate,
        BizDate: newDate,
        NonSalesWithTenderDesc,
        totalNonSales,
        totalNonSalesCounter,
        orderData,
        NonSalesDataReturned,
        cashierBreakDownReturned,
        totalCashierAmount,
        totalShortOver,
        shortOverDataReturned,
        totalShortOverNonCash,
        shortOverNonCashDataReturned,
        CMCash,
        CMFloat,
        CMOverShort,
        CMPickUp,
        totalPaymentCash,
        totalPaymentNonCash,
        paymentDataReturned,
        ChangeAmount,
        TenderAmount,
        VoidPaymentAmount,
        VoidPaymentCount,
        totalNonCashQty,
        NonSalesPaymentDataReturned,
        totalNonSalesCount,
        dataDiscount,
        dataDiscountVAT,
        dataDiscountVATE,
        salesData,
        totalGrossAmt,
        totalvat,
        openingData,
        closingData,
        dataGrossBreakDownReturned,
        totalGrossBreakDownVAT,
        totalGrossBreakDownVATE,
        PosId: reqField.locCode,
        TCQty,
        OrderQty,
        storeName: reqField.branch,
        storeCode: reqField.costcenter,
      });
    } catch (e) {
      // Check for authentication errors first
      if (e.response && e.response.status === 401) {
        handleAuthError(toast, navigate);
        return;
      }

      toast({
        title: "Error",
        position: "top-right",
        description: e.message,
        status: "error",
        duration: 5000,
        isClosable: true,
      });
    } finally {
      setDataLoading(false);
    }
  };

  useEffect(() => {
    const fetchStores = async () => {
      setDataLoading(true);
      try {
        const resStores = await axios.post(
          `${process.env.REACT_APP_BACKEND_API_URL}/maintenance/getBrands`,
          {
            brandId: 2,
          },
        );
        setStores(resStores.data || []);

        // Get user's assigned stores
        const storeName = localStorage.getItem("storeName");
        let assignedStores = [];

        if (storeName) {
          try {
            // Try to parse as JSON array first
            const parsed = JSON.parse(storeName);
            assignedStores = Array.isArray(parsed) ? parsed : [storeName];
          } catch {
            // If parsing fails, it's a regular string
            assignedStores = [storeName];
          }
        }

        setUserAssignedStores(assignedStores);

        // Filter stores to only show assigned ones
        const userStores = resStores.data.filter((store) =>
          assignedStores.includes(store.StoreName),
        );
        setFilteredStores(userStores);

        if (role === "store") {
          // If user has only one store, auto-select it
          if (userStores.length === 1) {
            const store = userStores[0];
            if (store && store.StoreName) {
              setReqField((prev) => ({
                ...prev,
                branch: store.StoreName,
                locCode: store.locCode,
                storecode: store.storecode,
                costcenter: store.costcenter || store.storecode,
              }));
            }
          }
          // If user has multiple stores, leave dropdown enabled for selection
        }

        setDataLoading(false);
      } catch (e) {
        // Check for authentication errors first
        if (e.response && e.response.status === 401) {
          handleAuthError(toast, navigate);
          return;
        }

        toast({
          title: "Error",
          position: "top-right",
          description: "Failed to fetch stores",
          status: "error",
          duration: 5000,
          isClosable: true,
        });
        setDataLoading(false);
      }
    };
    fetchStores();
  }, [role, toast]);

  const [file, setFile] = useState();

  function handleChange(event) {
    setFile(event.target.files[0]);
  }

  function handleSubmit(event) {
    event.preventDefault();
    const url = "https://reports.ftsfood.com.ph/api/dfmupload";
    const formData = new FormData();
    formData.append("destination", reqField.locCode);
    formData.append("file", file);
    formData.append("fileName", file.name);

    const config = {
      headers: {
        "content-type": "multipart/form-data",
      },
    };
    axios.post(url, formData, config).then((response) => {
      //console.log(reqField.locCode);

      //Save
      const fn = response.data;
      const loccode = reqField.locCode;
      //console.log(fn.success);
      //if (response.data.includes(".rar")){
      try {
        const uploadresponse = axios.post(
          `${process.env.REACT_APP_BACKEND_API_URL}/dfmdetails`,
          {
            foldername: loccode,
            filename: fn.success,
            dob: reqField.date,
          },
        );
      } catch (err) {
        // Check for authentication errors first
        if (err.response && err.response.status === 401) {
          handleAuthError(toast, navigate);
          return;
        }

        alert(err);
      }
      //alert("The file has been successfully uploaded. Please return in a few minutes.");
      toast({
        title: "Success",
        position: "top-right",
        description:
          "The file has been successfully uploaded. Please return in a few minutes.",
        status: "success",
        duration: 5000,
        isClosable: true,
      });
      //}else{
      //alert(response.data);
      //}
    });
  }

  return (
    <>
      <Box
        mt={6}
        mb={0}
        pl={6}
        py={4}
        display={"flex"}
        gap={4}
        alignItems={"center"}
        flexDirection={{ base: "column", lg: "row" }}
        flexWrap={{ base: "wrap", lg: "nowrap" }}
        bg="gray.100"
        borderRadius="md"
      >
        <SearchableStoreSelect
          options={(role === "store" ? filteredStores : stores).map(
            (store) => ({
              value: store.locCode,
              label: store.StoreName,
            }),
          )}
          value={reqField.locCode}
          onChange={(val) => handleBranchChange({ target: { value: val } })}
          isDisabled={
            (role === "store" && userAssignedStores.length <= 1) || dataLoading
          }
          placeholder={
            role === "store" && userAssignedStores.length <= 1
              ? reqField.branch || "Loading..."
              : "Select Branch"
          }
        />

        <Box
          border="1px"
          borderColor="gray.300"
          borderRadius={"md"}
          display={"flex"}
          justifyContent={"center"}
          alignItems={"center"}
          bg="white"
          boxShadow="sm"
          h="40px"
          px={3}
        >
          <DatePicker
            name="date"
            disabled={dataLoading}
            minDate={new Date(2025, 3, 1)}
            maxDate={new Date()}
            selected={reqField.date}
            onChange={(date) => handleDateChange(date)}
            className="custom-date-picker"
            customInput={
              <div style={{ position: "relative" }}>
                <input
                  className="custom-date-picker-input"
                  value={reqField.date.toLocaleDateString()}
                  readOnly
                />
                <img
                  src="/calendar.svg"
                  className="calendar-icon"
                  alt="Calendar Icon"
                  style={{
                    position: "absolute",
                    right: "20px",
                    top: "50%",
                    transform: "translateY(-50%)",
                    width: "20px",
                    height: "auto",
                  }}
                />
              </div>
            }
          />
        </Box>

        <Button
          colorScheme={color}
          size="md"
          onClick={() => handleGenerateReport(reqField.date, reqField.branch)}
          isDisabled={dataLoading}
          boxShadow="sm"
        >
          Generate Report
        </Button>

        <Button colorScheme={color} size="md" boxShadow="sm" isDisabled={!data}>
          {data ? (
            <PDFDownloadLink
              document={<AlohaPDFComponent data={data} />}
              fileName={`EODReport-${reqField.branch}-${getFormatterDate(reqField.date)}.pdf`}
            >
              {({ loading }) =>
                loading ? "Loading document..." : "Download Report"
              }
            </PDFDownloadLink>
          ) : (
            "Download Report"
          )}
        </Button>
      </Box>

      <Box mt={0} mb={8} height="80vh">
        {dataLoading ? (
          <Box
            height={"100%"}
            display={"flex"}
            justifyContent={"center"}
            alignItems={"center"}
          >
            <Spinner
              thickness="4px"
              speed="0.65s"
              emptyColor="gray.200"
              color="blue.500"
              size="xl"
            />
            <Text
              css={{ animation: `${blink} 1s linear infinite` }}
              marginLeft={4}
            >
              Fetching Data.....
            </Text>
          </Box>
        ) : (
          <PDFViewer
            showToolbar={false}
            style={{ width: "100%", height: "100%" }}
          >
            <AlohaPDFComponent data={data} />
          </PDFViewer>
        )}
      </Box>
    </>
  );
};

export default SalesSBC;
